import React from 'react';

import './styles.css';

import MainMenu from '../../components/MainMenu';

function MainView(props) {
    return (
        <main className='main-view'>
            <MainMenu
                selected={props.currentPage ? props.currentPage : 'inicio'}
                studentMenu={props.studentMenu}
                coachMenu={props.coachMenu}
                admFinMenu = {props.admFinMenu}
                adminMenu = {props.adminMenu}
            />
            <section className='main-view-section'>
                {props.children}
            </section>
        </main>
    )
}

export default MainView;